import React, { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './activityItem.module.scss';
import Truncate from 'react-truncate';
import { MAX_ACTIVITY_DESCRIPTION_LINES } from './ActivityItem';

interface ActivityItemProps {
  content: string;
  render: (content: string) => ReactNode;
  canTruncateContent?: boolean;
  expanded: boolean;
  setExpanded: () => void;
  truncated: boolean;
  handleTruncate: (_truncated: boolean) => void;
}

const ActivityItemDescription = ({
  content,
  render,
  expanded,
  setExpanded,
  truncated,
  handleTruncate,
  canTruncateContent = true,
}: ActivityItemProps) => {
  return (
    <div
      data-cy="activityDescription"
      className={classnames(styles.activityDescription)}
      onClick={setExpanded}
    >
      {canTruncateContent ? (
        <>
          <Truncate
            lines={!expanded && MAX_ACTIVITY_DESCRIPTION_LINES}
            onTruncate={handleTruncate}
          >
            {render(content)}
          </Truncate>
          {truncated && !expanded ? (
            <div
              data-cy="collapsedOverlay"
              className={classnames(styles.collapsedOverlay)}
            ></div>
          ) : null}
        </>
      ) : (
        render(content)
      )}
    </div>
  );
};

export default ActivityItemDescription;
